import { useState } from "react";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";

export const ATTRIBUTION_COOKIE_NAME = "attribution";
export const PARAM_NAMES = [
    "afid",
    "arid",
    "cid",
    "ccuid",
    "jid",
    "sid",
    "_branch_match_id",
];

const MarketingAttributionStore = ({ location }) => {
    const [locationProcessed, setLocationProcessed] = useState(false);
    const [cookies, setCookie] = useCookies([ATTRIBUTION_COOKIE_NAME]);
    const attribution = cookies.attribution || {};

    if (!locationProcessed && location?.search) {
        const searchParams = new URLSearchParams(location.search.substring(1));
        setLocationProcessed(true);

        PARAM_NAMES.forEach(paramName => {
            const value = searchParams.get(paramName);
            if (value && value !== "") {
                attribution[paramName] = value;
            }
        });

        setCookie(ATTRIBUTION_COOKIE_NAME, attribution, { path: "/" });
    }

    return null;
};

MarketingAttributionStore.propTypes = {
    location: PropTypes.shape({
        href: PropTypes.string.isRequired,
        search: PropTypes.string,
    }),
};

export default MarketingAttributionStore;
